import type { ScimTokenDTO } from '../scimToken.types';
import dayjs from 'dayjs';
import i18next from 'i18next';

export class ScimTokenModel {
  private readonly _dto: ScimTokenDTO;

  constructor(dto: ScimTokenDTO) {
    this._dto = dto;
  }

  get originDTO(): ScimTokenDTO {
    return this._dto;
  }

  get id(): string {
    return this._dto.id;
  }

  get tenantId(): string {
    return this._dto.tenantId;
  }

  get description(): string {
    return this._dto.description ?? '';
  }

  get active(): boolean {
    return this._dto.active;
  }

  get token(): string {
    return this._dto.token ?? '';
  }

  get expiresAt(): string {
    return this._dto.expiresAt ? dayjs(this._dto.expiresAt).format('YYYY.MM.DD HH:mm') : '';
  }

  get lastUsedAt(): string {
    return this._dto.lastUsedAt ? dayjs(this._dto.lastUsedAt).format('YYYY.MM.DD HH:mm') : '';
  }

  get createdDate(): string {
    return this._dto.createdDate ? dayjs(this._dto.createdDate).format('YYYY.MM.DD HH:mm') : '';
  }

  get isExpired(): boolean {
    if (!this._dto.expiresAt) return false;
    return dayjs(this._dto.expiresAt).isBefore(dayjs());
  }

  get statusLabel(): string {
    if (!this.active) {
      return i18next.t('ScimToken.Status.Revoked', { defaultValue: '비활성' });
    }
    if (this.isExpired) {
      return i18next.t('ScimToken.Status.Expired', { defaultValue: '만료됨' });
    }
    return i18next.t('ScimToken.Status.Active', { defaultValue: '활성' });
  }

  get statusColor(): 'red' | 'gray' | 'green' {
    if (!this.active) return 'red';
    if (this.isExpired) return 'gray';
    return 'green';
  }
}
